import React from 'react';
import { createIcon } from './create-icon';
import './icon-attach-to-sheet.scss';

export const IconAttachToSheet = createIcon(<div className="icon-attach-to-sheet" />);
